
import { defineComponent, onMounted, ref } from "vue";
import AuthenticatorHeader from "./AuthenticatorHeader.vue";
import NavigationButton from "./NavigationButton.vue";
import { useGammaAuthenticator } from "@/composeable/gamma-authenticator";
import { AuthUIState } from "@/types/auth-ui";
import { focusRequiredEmptyInput } from "@/util/auth-ui";

export default defineComponent({
  components: { AuthenticatorHeader, NavigationButton },
  setup() {
    const { startResetPassword, authUIData } = useGammaAuthenticator();

    const email = ref("");
    const loading = ref(false);
    const errorMessage = ref<string | undefined>(undefined);
    const emailRef = ref();

    onMounted(() => {
      email.value = authUIData.value?.email || "";
      errorMessage.value = authUIData.value?.errorMessage;
    });

    async function initResetPassword() {
      focusRequiredEmptyInput([emailRef.value.$el]);
      if (!email.value) return;

      loading.value = true;
      try {
        await startResetPassword(email.value);
      } catch (error) {
        errorMessage.value = error.message;
        console.error(error);
      }
      loading.value = false;
    }

    return {
      AuthUIState,
      email,
      loading,
      emailRef,
      errorMessage,
      initResetPassword,
    };
  },
});
